/**
 * @deprecated This function is kept for backward compatibility but no longer performs validation.
 * All API routes are now valid endpoints in pages/api.
 * The validation logic has been removed as api_endpoints and _functions directories have been consolidated.
 */
export function getAPIRoute(route) {
  if (!route) return route; // Handle the ? null : "real-url" pattern for useGets

  // Remove Query Parameters and return the route as-is
  return route.split('?')[0];
}
